import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Grid from '../../grid/Grid';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';

const PRSDetail = ({ selectedLog, }) => {
  const renderActivityLogInformation = () => {
    const formattedLog = Object.keys(selectedLog)
      .filter(key => !!selectedLog[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = selectedLog[key];
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedLog);
    const exclusions = [ 'Activities', ];

    return (
      <FieldSet title="payable reminder activity log" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  const renderActivities = () => {
    const activityModel = Grid.toModelFromList(selectedLog.activities, {
      headerFormatter: value => _.startCase(value.header),
    });

    const formattedActivities = selectedLog.activities.map((activity) => {
      const formatted = activity;
      formatted.timestamp = moment(activity.timestamp * 1000).utc().format();
      return formatted;
    });

    const rows = activityModel.format(formattedActivities);

    return (
      <FieldSet title="Activities" style={{ maxHeight: '400px', }}>
        <Grid
          headers={activityModel.headers}
          rows={rows}
        />
      </FieldSet>
    );
  };

  return (
    <>
      {renderActivityLogInformation()}
      {renderActivities()}
    </>
  );
};

PRSDetail.propTypes = {
  selectedLog: PropTypes.instanceOf(Object).isRequired,
};

export default PRSDetail;
